import React, { useCallback, useContext, useEffect, useRef } from "react";
import "./TrainPublicPage.scss";
import { SliderSettings } from "../../Constant";
import Slider from "react-slick";
import { Grid } from "@mui/material";
import { Slide1 } from "./main-slide/Slide1";
import { Slide2 } from "./main-slide/Slide2";
import { Slide3 } from "./main-slide/Slide3";
import MyContext from "../../contexts/MyContext";
import TrainStationApiService from "../../adapters/xhr/TrainStationApiService";
import ClientSettingApiService from "../../adapters/xhr/ClientSettingApiService";
import { formatDate, formatDepartureDate, formatTime } from "../../Utils";
import Logo from "../../static/tib-logo-4f.png";

export const TrainPublicPage = (props) => {
  let sliderRef = React.createRef();
  const myContext = useContext(MyContext);

  const fetchTrainStations = useCallback(async () => {
    let response = await TrainStationApiService.getAll();
    if (response.isSuccess) {
      myContext.changeTrainStations(response.data);
    }
  }, []);

  const getClientAppSettings = useCallback(async () => {
    let response = await ClientSettingApiService.GetClientAppSettings();
    if (response.isSuccess) {
      myContext.changeTotalCostSEKMax(response.data.totalCostSEKMax);
      myContext.changeAllowFileUploadExtension(response.data.allowFileUploadExtension);
    }
  }, []);

  useEffect(() => {
    sliderRef.slickGoTo(myContext.activeSlide, false);
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [myContext.activeSlide]);

  useEffect(() => {
    getClientAppSettings();
    if (!myContext.trainStations || myContext.trainStations.length === 0) fetchTrainStations();
  }, []);

  const fetchDepartureTimeList = async () => {
    let response = await TrainStationApiService.getDepartureTimeList(
      myContext.departureStation.code,
      myContext.arrivalStation.code,
      null,
      formatDate(myContext.departureDate)
    );
    if (response.isSuccess) {
      let data = response.data
        .map((option, key) => {
          let rObj = {};
          rObj["key"] = key;
          rObj["value"] = formatTime(option);
          rObj["data"] = option;
          return rObj;
        })
        .sort((a, b) => {
          if (new Date(a.data) > new Date(b.data)) {
            return 1;
          }
          if (new Date(a.data) < new Date(b.data)) {
            return -1;
          }
          return 0;
        });
      myContext.changeDepartureTimeOptions(data);
    }
  };

  const getDistance = async () => {
    let response = await TrainStationApiService.getDistance(
      myContext.departureStation.code,
      myContext.arrivalStation.code,
      formatDepartureDate(myContext.departureDate, myContext.departureTime).toISOString()
    );
    if (response?.isSuccess) {
      myContext.changeDistance(response.data);
    }
  };

  useEffect(() => {
    if (myContext.departureTimeOptions) myContext.changeDepartureTime(null);
  }, [myContext.departureTimeOptions]);

  useEffect(() => {
    if (myContext.departureDate && myContext.departureStation && myContext.arrivalStation && !myContext.departureTime) {
      fetchDepartureTimeList();
      myContext.changeDepartureTime(null);
    }
  }, [myContext.departureDate, myContext.departureStation, myContext.arrivalStation]);

  useEffect(() => {
    if (myContext.departureDate && myContext.departureTime && myContext.departureStation && myContext.arrivalStation) {
      getDistance();
    }
  }, [myContext.departureDate, myContext.departureTime, myContext.departureStation, myContext.arrivalStation]);

  const setActiveSlide = (index) => {
    myContext.changeActiveSlide(index);
  };
  return (
    <MyContext.Consumer>
      {(context) => (
        <Grid container className="container custom padding top-2 bottom-2 left-0 right-0" justifyContent="center">
          <Grid item>
            <div hidden={context.activeSlide !== 0}>
              <img src={Logo} className="logo" alt="Tåg i Bergslagen, logo" />
            </div>
            <Slider ref={(slider) => (sliderRef = slider)} {...SliderSettings} beforeChange={(_, next) => setActiveSlide(next)}>
              <Slide1 />
              <Slide2 />
              <Slide3 />
            </Slider>
          </Grid>
        </Grid>
      )}
    </MyContext.Consumer>
  );
};
